export const GET_MATCHED_COACHES = 'GET_MATCHED_COACHES';
export const GET_MATCHED_COACHES_SUCCESS = 'GET_MATCHED_COACHES_SUCCESS';
export const GET_MATCHED_COACHES_ERROR = 'GET_MATCHED_COACHES_ERROR';

export const GET_CAREER_MATCHED_COACHES = 'GET_CAREER_MATCHED_COACHES';